import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { useSelector } from "react-redux";

const Layout = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  return (
    <React.Fragment>
      <Navbar />
      <div className="columns mt-6" style={{ minHeight: "100vh" }}>
        {user && user.role === "admin" && (
        <div className="column has-background-link is-narrow">
             <Sidebar />
        </div>
        )}
        <div className="column has-background-light main-container">
          <div className="box">
            <main>
             {children}
            </main>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Layout;
